import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import { EditUserModalComponent } from 'app/modules/user-management/component/edit-user-modal/edit-user-modal.component';
import module from 'app/modules/user-management/user-management.module'

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./users.page.scss']
})
export class UsersPage {
  public userInfo$ = this.userMangementService.userInfo$

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private userMangementService: UserManagementService) {
  }

  ngOnInit() {
    this.getUsersInfo()
  }

  getUsersInfo(){
    this.userMangementService.getUserInfo(this.filterData.pageNumber,this.filterData.pageSize).subscribe()
  }

  nextPage() {
    this.filterData.pageNumber = this.filterData.pageNumber + 1
    this.getUsersInfo()
  }

  previousPage() {
    this.filterData.pageNumber = this.filterData.pageNumber - 1
    this.getUsersInfo()
  }

  editUserModal(userData: any) {
    const dialogRef = this.dialog.open(EditUserModalComponent, {
      data: userData, // Pass your parameters here
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getUsersInfo()
      console.log(`Dialog result: ${result}`);
    });
  }
}
